import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UnauthorizedComponent } from './modules/tariff/tariff-views/auth/unauthorized/unauthorized.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'tarifario',
    pathMatch: 'full',
  },
  {
    path: 'tarifario',
    loadChildren: () =>
      import('./modules/tariff/tariff.module').then((m) => m.TariffModule),
  },
  {
    path: 'no-autorizado',
    component: UnauthorizedComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
